import { useEffect } from 'react';
import PageLayout from '../../components/base/PageLayout';

export default function Privacy() {
  useEffect(() => {
    document.title = 'プライバシーポリシー - 個人情報の取り扱いについて｜執事ベル';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '執事ベル オフィシャルサイトにおける個人情報の取り扱いに関するプライバシーポリシー。お問い合わせフォーム、サービスお申し込み時に取得する個人情報の利用目的、管理方法、第三者提供の有無、開示請求の手続きなどを明記。お客様の個人情報を適切に保護し、安心してサービスをご利用いただくための方針です。');
    }

    // Add Keywords meta tag
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'プライバシーポリシー, 個人情報保護, 情報管理, セキュリティ, 利用規約');
    } else {
      const keywordsTag = document.createElement('meta');
      keywordsTag.name = 'keywords';
      keywordsTag.content = 'プライバシーポリシー, 個人情報保護, 情報管理, セキュリティ, 利用規約';
      document.head.appendChild(keywordsTag);
    }

    // Add Canonical URL
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', `${import.meta.env.VITE_SITE_URL || "https://butlerbell.jp"}/privacy`);
    } else {
      const canonical = document.createElement('link');
      canonical.rel = 'canonical';
      canonical.href = `${import.meta.env.VITE_SITE_URL || "https://butlerbell.jp"}/privacy`;
      document.head.appendChild(canonical);
    }

    // Add Last-modified
    const lastModified = document.querySelector('meta[name="last-modified"]');
    if (lastModified) {
      lastModified.setAttribute('content', new Date().toISOString().split('T')[0]);
    } else {
      const lastModTag = document.createElement('meta');
      lastModTag.name = 'last-modified';
      lastModTag.content = new Date().toISOString().split('T')[0];
      document.head.appendChild(lastModTag);
    }

  }, []);

  return (
    <PageLayout hero={<>
<section className="py-32 bg-gradient-to-br from-[#1a1a1a] via-[#2a2a2a] to-[#1a1a1a]">
        <div className="max-w-7xl mx-auto px-8 text-center">
          <h1 
            className="text-3xl md:text-5xl font-light text-white mb-8 tracking-wide"
            style={{ fontFamily: '"Noto Serif JP", serif' }}
          >
            プライバシーポリシー
          </h1>
          <p 
            className="text-xl md:text-2xl text-amber-400 font-light tracking-wider"
            style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
          >
            個人情報の取り扱いについて
          </p>
        </div>
      </section>
</>}>
      {/* Hero Section */}
      

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-8">
          <div className="prose prose-lg max-w-none">
            <div className="mb-12">
              <p 
                className="text-lg text-gray-700 leading-relaxed mb-8"
                style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
              >
                執事ベル（以下「当サービス」）は、お客様の個人情報保護の重要性を認識し、個人情報の保護に関する法律（個人情報保護法）を遵守し、適切な取り扱いを行います。
              </p>
            </div>

            <div className="space-y-12">
              <div>
                <h2 
                  className="text-3xl font-medium text-[#1a1a1a] mb-6"
                  style={{ fontFamily: '"Noto Serif JP", serif' }}
                >
                  1. 個人情報の収集について
                </h2>
                <div 
                  className="text-gray-700 leading-relaxed space-y-4"
                  style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                >
                  <p>当サービスでは、以下の場合に個人情報を収集させていただきます：</p>
                  <ul className="list-disc list-inside space-y-2 ml-4">
                    <li>お問い合わせフォームからのご連絡時</li>
                    <li>サービスのお申し込み時</li>
                    <li>研修・講座へのお申し込み時</li>
                    <li>メールマガジンの配信登録時</li>
                  </ul>
                </div>
              </div>

              <div>
                <h2 
                  className="text-3xl font-medium text-[#1a1a1a] mb-6"
                  style={{ fontFamily: '"Noto Serif JP", serif' }}
                >
                  2. 収集する個人情報の項目
                </h2>
                <div 
                  className="text-gray-700 leading-relaxed space-y-4"
                  style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                >
                  <p>当サービスでは、以下の個人情報を収集する場合があります：</p>
                  <ul className="list-disc list-inside space-y-2 ml-4">
                    <li>お名前</li>
                    <li>メールアドレス</li>
                    <li>電話番号</li>
                    <li>ご住所</li>
                    <li>会社名・団体名</li>
                    <li>お問い合わせ内容</li>
                  </ul>
                </div>
              </div>

              <div>
                <h2 
                  className="text-3xl font-medium text-[#1a1a1a] mb-6"
                  style={{ fontFamily: '"Noto Serif JP", serif' }}
                >
                  3. 個人情報の利用目的
                </h2>
                <div 
                  className="text-gray-700 leading-relaxed space-y-4"
                  style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                >
                  <p>収集した個人情報は、以下の目的で利用いたします：</p>
                  <ul className="list-disc list-inside space-y-2 ml-4">
                    <li>お問い合わせへの回答</li>
                    <li>サービスの提供</li>
                    <li>研修・講座の実施</li>
                    <li>メールマガジンの配信</li>
                    <li>サービス向上のための分析</li>
                    <li>重要なお知らせの配信</li>
                  </ul>
                </div>
              </div>

              <div>
                <h2 
                  className="text-3xl font-medium text-[#1a1a1a] mb-6"
                  style={{ fontFamily: '"Noto Serif JP", serif' }}
                >
                  4. 個人情報の第三者提供
                </h2>
                <div 
                  className="text-gray-700 leading-relaxed space-y-4"
                  style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                >
                  <p>当サービスは、以下の場合を除き、お客様の個人情報を第三者に提供することはありません：</p>
                  <ul className="list-disc list-inside space-y-2 ml-4">
                    <li>お客様の同意がある場合</li>
                    <li>法令に基づく場合</li>
                    <li>人の生命、身体または財産の保護のために必要がある場合</li>
                    <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合</li>
                  </ul>
                </div>
              </div>

              <div>
                <h2 
                  className="text-3xl font-medium text-[#1a1a1a] mb-6"
                  style={{ fontFamily: '"Noto Serif JP", serif' }}
                >
                  5. 個人情報の管理
                </h2>
                <div 
                  className="text-gray-700 leading-relaxed space-y-4"
                  style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                >
                  <p>当サービスは、個人情報の正確性を保ち、これを安全に管理いたします。個人情報への不正アクセス、紛失、破壊、改ざん、漏洩などを防ぐため、適切な安全対策を実施いたします。</p>
                </div>
              </div>

              <div>
                <h2 
                  className="text-3xl font-medium text-[#1a1a1a] mb-6"
                  style={{ fontFamily: '"Noto Serif JP", serif' }}
                >
                  6. 個人情報の開示・訂正・削除
                </h2>
                <div 
                  className="text-gray-700 leading-relaxed space-y-4"
                  style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                >
                  <p>お客様は、当サービスが保有する個人情報について、開示、訂正、削除を求めることができます。お客様からのご請求については、本人確認を行った上で、合理的な期間内に対応いたします。</p>
                </div>
              </div>

              <div>
                <h2 
                  className="text-3xl font-medium text-[#1a1a1a] mb-6"
                  style={{ fontFamily: '"Noto Serif JP", serif' }}
                >
                  7. Cookieについて
                </h2>
                <div 
                  className="text-gray-700 leading-relaxed space-y-4"
                  style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                >
                  <p>当サービスでは、サービスの利便性向上のためCookieを使用する場合があります。Cookieの使用を希望されない場合は、ブラウザの設定でCookieを無効にすることができます。</p>
                </div>
              </div>

              <div>
                <h2 
                  className="text-3xl font-medium text-[#1a1a1a] mb-6"
                  style={{ fontFamily: '"Noto Serif JP", serif' }}
                >
                  8. プライバシーポリシーの変更
                </h2>
                <div 
                  className="text-gray-700 leading-relaxed space-y-4"
                  style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                >
                  <p>当サービスは、法令の変更等に伴い、本プライバシーポリシーを変更する場合があります。変更後のプライバシーポリシーは、当サイトに掲載した時点から効力を生じるものとします。</p>
                </div>
              </div>

              <div>
                <h2 
                  className="text-3xl font-medium text-[#1a1a1a] mb-6"
                  style={{ fontFamily: '"Noto Serif JP", serif' }}
                >
                  9. お問い合わせ窓口
                </h2>
                <div 
                  className="text-gray-700 leading-relaxed space-y-4"
                  style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
                >
                  <p>個人情報の取り扱いに関するお問い合わせは、以下までご連絡ください：</p>
                  <div className="bg-[#f5f5f5] p-6 rounded-lg">
                    <p><strong>執事ベル</strong></p>
                    <p>メール：info@butlerbell.jp</p>
                    <p>住所：〒135-0064 東京都江東区青海2丁目7−4</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-16 text-center">
              <p 
                className="text-sm text-gray-500"
                style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
              >
                制定日：2024年12月19日<br />
                最終更新日：2024年12月19日
              </p>
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
}
